module.exports = __webpack_public_path__ + "img/banerFlash.e99e3fac.jpg";